module.exports = __webpack_public_path__ + "static/grafika4-6143b686f01d02e1e538985823683335.png";